import { useTheme } from '@mui/material';
import React from 'react';
import {
  StyledCheckbox,
  StyledCheckboxIcon,
  StyledCheckboxIconChecked,
  StyledFormControlLabel,
} from './styles';
import type { CheckboxProps } from './types';
import { CheckboxClasses } from './types';

export const Checkbox = ({
  label,
  value,
  disabled = false,
  onChangeEvent,
  error,
  checkboxId,
  color,
  sx = {},
}: CheckboxProps) => {
  const palleteType = useTheme().palette.type;
  return (
    <StyledFormControlLabel
      control={
        <StyledCheckbox
          icon={
            <StyledCheckboxIcon
              color={color}
              disabled={disabled}
              className={CheckboxClasses[palleteType]}
            />
          }
          sx={sx}
          checkedIcon={
            <StyledCheckboxIconChecked color={color} disabled={disabled} />
          }
          onChange={onChangeEvent}
          inputProps={{ role: 'checkbox', 'aria-label': checkboxId }}
          checked={value}
          disableRipple
        />
      }
      color={color}
      label={label}
      className={`${error ? CheckboxClasses.error : ''} ${
        CheckboxClasses[palleteType]
      }`}
    />
  );
};
